module.exports = __webpack_public_path__ + "static/app-ser-20a0f5428a32275ebf1dbee37e5aa251.png";